"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _priceFormat = _interopRequireDefault(require("@deosite/helpers/priceFormat"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _CurrencyProvider = require("../REST/CurrencyProvider");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
var __jsx = _react["default"].createElement;
function usePriceWithCurrency() {
  var _useCurrency = (0, _CurrencyProvider.useCurrency)(),
    currency = _useCurrency.currency;
  return function (price) {
    var isReturnPlainText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return isReturnPlainText ? "".concat((0, _priceFormat["default"])(price), " ").concat(currency === null || currency === void 0 ? void 0 : currency.symbol) : __jsx(_Box["default"], {
      as: "span"
    }, __jsx(_Box["default"], {
      as: "span",
      "data-test": "total-checkout"
    }, (0, _priceFormat["default"])(price), "\xA0"), __jsx(_Box["default"], {
      as: "span"
    }, currency === null || currency === void 0 ? void 0 : currency.symbol));
  };
}
var _default = usePriceWithCurrency;
exports["default"] = _default;